import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Controls from '../components/FormsUI';
import { useAuth } from '../utility/auth';
import RoleMasterController from '../controller/RoleMaster.Controller.jsx';
import CustomizedSnackbars from '../components/Alert';
import EditIcon from '@mui/icons-material/Edit';
import Load from '../components/FormsUI/Loader/index';
import DeleteIcon from '@mui/icons-material/Delete';
import '../css/style.css';
import { tokens } from '../theme';
import {
  Container,
  Grid,
  useTheme,
  Box,
  Stack,
  IconButton
} from '@mui/material';
import ExceptionHandlerController from '../controller/ErrorLogsController';
const INITIAL_FORM_STATE = {
  roleName: '',
  roleId: '',
  reportingTo: null
};

const FORM_VALIDATION = Yup.object().shape({
  roleName: Yup.string()
    .matches(/^[A-Za-z ]*$/, 'Role name is not in correct format')
    .trim('No white space allowed')
    .strict(true)
    .min(3)
    .max(50, 'Name should not be exceed 50 Character')
    .required('Role name is required'),
  roleId: Yup.string()
    .matches(/^[A-Za-z0-9 ]*$/, 'Role Id is not in correct format')
    .trim('No white space allowed')
    .strict(true)
    .min(2)
    .max(50, 'Role Id should not be exceed 50 Character')
    .optional(),
  reportingTo: Yup.object()
    .nullable()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required('Reporting To is required'),
    })
    .required('Reporting To is required'),

});
let requestType = '';

const RoleMaster = () => {
  const roleController = new RoleMasterController();
  const exceptionHandlerController = new ExceptionHandlerController();
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem('user'));
  const { data, token } = user;
  const { userid: userId, tenantid: tenantId } = data.UserInfo;
  const [loader, setLoader] = useState(false); //set false
  const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
  const [alert, setAlert] = useState({ counter: 0, type: '', msg: '' });
  const [popup, setPopUp] = useState(false);
  const [allRoles, setAllRoles] = useState([]);
  const [reportingRoles, setReportingRoles] = useState([{ label: 'Self', value: '68affcbd55afd7f3779f9d05' }]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };

  const fetchRoles = async () => {
    setLoader(true);
    try {
      setAllRoles([]);
      // setReportingRoles([{ label: 'Self', value: '68affcbd55afd7f3779f9d05' }]);
      const result = await roleController.GetRoles(tenantId, token);
      const roleData = result?.data?.body;
      setAllRoles(roleData || []);
      // setReportingRoles(prev => [
      //   ...prev,
      //   ...(roleData?.length >= 1 ? roleData.map(item => ({
      //     value: item.id,
      //     label: item.roleName
      //   })) : "")
      // ])
      setReportingRoles([
        { label: "Self", value: "68affcbd55afd7f3779f9d05" },
        ...(roleData?.length
          ? roleData.map((item) => ({
            value: item.id,
            label: item.roleName,
          }))
          : []),
      ]);

    } catch (error) {
      // handleException(error, "Fetching all roles");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const columns = [
    {
      headerName: 'ID',
      field: 'id',
      hide: true,
      filterable: false,
      width: 210,
    },
    { headerName: 'Role Name', field: 'roleName', width: 210 },
    { headerName: 'Role Id', field: 'roleId', width: 210 },
    { headerName: 'Reporting To', field: 'reportingTo', width: 210 },
    {
      field: 'action',
      headerName: 'Action',
      width: 210,
      sortable: false,
      filterable: false,
      disableExport: true,
      disableClickEventBubbling: true,

      renderCell: (params) => {
        const onClick = (e, type) => {
          let caughtError;
          try {
            setAlert({ counter: 0, type: '', msg: '' });
            const currentRow = params?.row;
            if (type === 'Edit') {
              requestType = 'Edit';
              // setUpdatedValues(() => currentRow);
              setUpdatedValues((prev) => ({
                ...currentRow,
                reportingTo: reportingRoles.find(role => role.label === currentRow.reportingTo),
              }));

              handleData();
            } else {
              if (type === 'Delete') {
                roleController.Delete(currentRow?.id, token).then((response) => {
                  if (response.status === 200) {
                    showAlert('success', 'Deleted successfully');
                    // setAllUsers((i) => {
                    //   return allUsers.filter(
                    //     (item) => item?.id !== currentRow.id
                    //   );
                    // });
                    fetchRoles();
                  } else if (response.data.status === 204) {
                    showAlert('error', response.data.message);
                  } else if (response?.status === 500) {
                    showAlert('error', response?.response?.data?.message);
                  }
                });
              }
            }
          } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = { logData, module: 'Role master onClick(Edit) method' };
            exceptionHandlerController.HandleException(logError);
          }
        };

        return (
          <Stack direction="row" spacing={2}>
            <>
              <IconButton onClick={(e) => onClick(e, 'Edit')}>
                <EditIcon type="button" color="primary" id="Edit" />
              </IconButton>
              <IconButton>
                <DeleteIcon
                  type="button"
                  color="secondary"
                  id="Delete"
                  onClick={(e) => onClick(e, 'Delete')}
                />
              </IconButton>
            </>
          </Stack>
        );
      },
    },
  ];

  const AddUser = () => {
    requestType = "";
    setUpdatedValues(() => INITIAL_FORM_STATE);
    handleData();
  };

  const handlePopup = (value) => setPopUp(() => value);
  const handleData = () => setPopUp(() => true);
  if (loader) return <Load />;

  const submitValues = (values) => {
    let submitData = {};
    // console.log("values :", values);

    // Common fields
    submitData.tenantId = tenantId;
    submitData.roleName = values?.roleName?.trim();
    submitData.roleId = values?.roleId?.trim();
    submitData.reportingTo = values?.reportingTo?.value || ""; // Handle Autocomplete object

    if (requestType === "Edit") {
      submitData.id = values?.id; // Ensure ID is included for update

      roleController
        .Update(submitData, token)
        .then((response) => {
          if (response.status === 200) {
            showAlert("success", response?.data?.message);
            handlePopup(false);
            fetchRoles();
          } else if (response?.data?.status === 204) {
            showAlert("error", response?.data?.message);
          } else if (response?.response?.status === 409) {
            showAlert("error", response?.response?.data?.message);
          } else if (response?.status === 500) {
            showAlert("error", response?.response?.data?.message);
          }
          setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
        })
        .catch((error) => {
          // console.error("Update Error:", error);
          showAlert("error", "Oops something went wrong.");
          setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
        });
    } else {
      // Create logic
      roleController
        .Create(submitData, token)
        .then((response) => {
          if (response?.status === 201) {
            handlePopup(false);
            showAlert("success", response?.data?.message);
            fetchRoles();
          } else if (response?.response?.status === 500) {
            showAlert("error", response?.response?.data?.message);
          } else if (response?.response?.status === 409) {
            showAlert("error", response?.response?.data?.message);
          }
          setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
        })
        .catch((error) => {
          console.error("Create Error:", error);
          showAlert("error", "Oops something went wrong.");
          setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
        });
    }
  };


  // const submitValues = (values) => {
  //   let submitData = {};
  //   console.log('values :', values);
  //   submitData.tenantId = values?.tenantId;
  //   submitData.roleName = values?.roleName;
  //   submitData.roleId = values?.roleId;
  //   submitData.reportingTo = values?.reportingTo;


  //   // let submitData = {};
  //   if (requestType === 'Edit') {
  //     // submitData.tenantsUserId = values?.id;
  //     values.reportingTo = values?.reportingTo?.value || "";
  //     delete values['reportingToId'];
  //     roleController
  //       .Update(values, token)
  //       .then((response) => {
  //         if (response.status === 200) {
  //           showAlert('success', response?.data?.message);
  //           handlePopup(false);
  //           setTimeout(() => setAlert({ counter: 0, type: '', msg: '' }), 10000);
  //           fetchRoles();
  //           // getAllUsers();
  //         } else {
  //           if (response?.data?.status === 204) showAlert('error', response?.data?.message);
  //           else if (response?.response?.status === 409)
  //             showAlert('error', response?.response?.data?.message);
  //           else if (response?.status === 500)
  //             showAlert('error', response?.response?.data?.message);
  //           setTimeout(() => setAlert({ counter: 0, type: '', msg: '' }), 10000);
  //         }
  //       })
  //       .catch((error) => {
  //         showAlert('error', 'Oops something went wrong.');
  //         setTimeout(() => setAlert({ counter: 0, type: '', msg: '' }), 10000);
  //       });
  //   } else {
  //     roleController
  //       .Create(values, token)
  //       .then((response) => {
  //         if (response?.status === 201) {
  //           handlePopup(false);
  //           showAlert('success', response?.data?.message);
  //           setTimeout(() => setAlert({ counter: 0, type: '', msg: '' }), 10000);
  //           fetchRoles();
  //         } else if (response?.response?.status === 500) {
  //           showAlert('error', response?.response?.data?.message);
  //         } else if (response?.response?.status === 409) {
  //           showAlert('error', response?.response?.data?.message);
  //         }
  //         setTimeout(() => setAlert({ counter: 0, type: '', msg: '' }), 10000);
  //       })
  //       .catch((error) => {
  //         showAlert('error', 'Oops something went wrong.');
  //         setTimeout(() => setAlert({ counter: 0, type: '', msg: '' }), 10000);
  //       });
  //   }
  // };

  return (
    <>
      <Box
        sx={{
          '& .formBg': {
            border: `1px solid ${colors.grey[900]}`,
            background: `${colors.primary[400]}`,
          },
          '& li.MuiBreadcrumbs-li h6': { color: `${colors.primary[200]}` },
          '& .MuiGrid-root.Mui-heading h2': {
            color: `${colors.primary[200]} !important`,
          },
        }}
      >
        <Grid container>
          <Grid className="breadcrumb-section">
            <Grid className="breadcrumb-container">
              <Grid className="Mui-li">
                <nav className="Mui-nav" aria-label="breadcrumb">
                  <ol className="">
                    <li className="MuiBreadcrumbs-li">
                      <h6 className="breadsub">Settings</h6>
                    </li>
                    <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                      /
                    </li>
                    <li className="MuiBreadcrumbs-li">
                      <h6>Role Master</h6>
                    </li>
                  </ol>
                </nav>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} className="adduser">
            <Controls.ActionButton onClick={() => AddUser()}>
              <span>Add New</span>
            </Controls.ActionButton>
          </Grid>
          <Grid item xs={12} className="formBg">
            <Container maxWidth="md" className="formClwidth">
              <div>
                <Controls.Grid columns={columns} data={allRoles} fileName={'Users'} />
                {popup && (
                  <Controls.Popup title="Role Details" openPopup={popup} setOpenPopup={handlePopup}>
                    <Formik
                      enableReinitialize
                      initialValues={{
                        ...(updatedValues || INITIAL_FORM_STATE),
                      }}
                      validationSchema={FORM_VALIDATION}
                      onSubmit={(values) => submitValues(values)}
                    >
                      {({ values, setFieldValue }) => (
                        <Form>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="roleName"
                                label="Role Name"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="roleId"
                                label="Role Id"
                                type="string"
                                inputProps={{ maxLength: 15 }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Controls.AutoComplete
                                name="reportingTo"
                                label="Reporting To"
                                options={reportingRoles}
                                value={values?.reportingTo}
                                onChange={(e, value) => {
                                  setFieldValue('reportingTo', value)
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} className="marginAuto"></Grid>
                            <Grid item xs={4} md={2} className="marginAuto">
                              <Controls.Button>Submit</Controls.Button>
                            </Grid>
                          </Grid>
                        </Form>
                      )}
                    </Formik>
                  </Controls.Popup>
                )}
              </div>
            </Container>
          </Grid>
          {alert?.counter > 0 && (
            <CustomizedSnackbars status={alert?.counter} msg={alert?.msg} type={alert?.type} />
          )}
        </Grid>
      </Box>
    </>
  );
};

export default RoleMaster;
